var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.298,
    height: 76.885,
    viewBox: "0 0 116.298 76.885",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(1 1)",
    opacity: 0.596
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_932",
    "data-name": "Trac\\xE9 932",
    d: "M114.3,9.607a9.849,9.849,0,0,0-2.463-6.4h0A10.118,10.118,0,0,0,104.691,0H9.607a9.879,9.879,0,0,0-6.9,2.956h0A9.974,9.974,0,0,0,0,9.607V65.524a8.945,8.945,0,0,0,2.71,6.4h0a9.879,9.879,0,0,0,6.9,2.956h95.084a9.879,9.879,0,0,0,6.9-2.956h0a8.945,8.945,0,0,0,2.71-6.4V9.607ZM76.856,34.486,109.864,7.144a7.192,7.192,0,0,1,.493,2.217V65.278a7.192,7.192,0,0,1-.493,2.217ZM104.691,3.941a5.883,5.883,0,0,1,2.217.493L57.149,45.818,7.39,4.434a7.193,7.193,0,0,1,2.217-.493h95.084ZM4.434,67.495a7.193,7.193,0,0,1-.493-2.217V9.607A7.193,7.193,0,0,1,4.434,7.39l33.008,27.1Zm5.173,3.449a7.288,7.288,0,0,1-2.463-.493L40.4,36.95,55.917,49.759a1.786,1.786,0,0,0,2.463,0L73.9,36.95,107.154,70.2a4.441,4.441,0,0,1-2.463.493H9.607Zm0,0",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.dffb64831b58f749dd2846d91a95cb0a.svg";
export { ForwardRef as ReactComponent };